import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslationFormChangeStatus, TranslationHeader } from '../../cpq-ml-translations/cpq-ml-translations.model';
import { TransactionIdLabelTranslationService } from './cpq-transaction-id-label-translation.service';

@Component({
    selector: 'cpq-transaction-id-label-translation-dialog',
    templateUrl: './cpq-transaction-id-label-translation-dialog.component.html',
    providers: [
        TransactionIdLabelTranslationService
    ],
    standalone: false
})
export class TransactionIdLabelTranslationDialogComponent {

  public defaultDictionaryId = 0;
  public translationHeader: TranslationHeader;
  public isTranslationFormInvalid = true;

  constructor(
    public dialogRef: MatDialogRef<TransactionIdLabelTranslationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public translations: any,
    public transactionIdLabelTranslationService: TransactionIdLabelTranslationService,
) { }

  ngOnInit() {
    this.translationHeader = new TranslationHeader();
    this.translationHeader.labelKey = 'Admin.CloudIntegration.TranslateTransactionIdLabelDialog.Column.Label';
    this.translationHeader.defaultLanguageKey = 'Admin.CloudIntegration.TranslateTransactionIdLabelDialog.Column.DefaultLanguage';
    this.translationHeader.selectLanguageKey = 'Admin.CloudIntegration.TranslateTransactionIdLabelDialog.Column.SelectLanguage';
    this.transactionIdLabelTranslationService
      .onSaveComplete
      .subscribe(() => {
        this.dialogRef.close(true);
      });
  }

  public onLanguageTranslationFormStatusChanged(formStatus: TranslationFormChangeStatus) {
    this.isTranslationFormInvalid = !formStatus.valid;
  }

  save() {
    this.transactionIdLabelTranslationService.onSave.emit();
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
